import { render, staticRenderFns } from "./UniversityStudentsTable.vue?vue&type=template&id=8eeeb9d4&scoped=true"
import script from "./UniversityStudentsTable.vue?vue&type=script&lang=js"
export * from "./UniversityStudentsTable.vue?vue&type=script&lang=js"
import style0 from "./UniversityStudentsTable.vue?vue&type=style&index=0&id=8eeeb9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eeeb9d4",
  null
  
)

export default component.exports